<template>
  <div
    v-if="loading"
    class="progress-container text-xs-center"
  >
    <v-progress-circular
      :color="color"
      indeterminate
      size="50"
    />
  </div>
</template>

<script>
import LoadingStateMixin from './mixins/LoadingStateMixin'

export default {
  name: 'LoadingStateMicro',

  mixins: [ LoadingStateMixin ]
}
</script>

<style scoped>
.progress-container {
  margin: 100px auto;
}
</style>
